// @core/api/endpoints/platform/get_platform_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformSettingsResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get platform settings
 * Retrieves the platform's configuration settings including security policies, feature flags, and integration configurations.
 */
export async function GetPlatformSettings(
  platform_id: string,
  options?: RequestOptions
): Promise<PlatformSettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/settings`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.get<PlatformSettingsResponse>(requestPath, { ...requestOptions });
}
